export default {
  contract: '0x0e3a36fc982c62e1fbc2a04bf201639e83fd3a49',
  network: 'mainnet'
}
